/* ============
 * State of the General module
 * ============
 *
 * The initial state of the General module.
 *
 * Used for storing general information that needs to
 * be available for several components.
 */

export default {
  showSpinner: false,
};
